import { Children } from "react";
import { Box, Container, Text } from "@chakra-ui/react";
import type { BoxProps, ContainerProps } from "@chakra-ui/react";

const BannerSeparator = () => <Text as="span"> • </Text>;

interface TrialBannerProps extends BoxProps {
  containerProps?: ContainerProps;
}

const TrialBanner = ({
  children,
  color = "yellow.100",
  containerProps = {},
  ...props
}: TrialBannerProps) => {
  const childrenArr = Children.toArray(children).filter(Boolean);

  if (!childrenArr.length) {
    return null;
  }

  return (
    <Box bg={color} borderBottomWidth="1px" {...props}>
      <Container py={4} maxW="8xl" {...containerProps}>
        {Children.map(childrenArr, (child, childI) => (
          <>
            {!!childI && <BannerSeparator />}
            {child}
          </>
        ))}
      </Container>
    </Box>
  );
};

export default TrialBanner;